import type { FC, PropsWithChildren } from 'react';

import { FORM_KEY } from 'constants/form-ids';
import { BaseCardWrapper as BaseCardWrapper1Xbet } from 'views/components/1xbet/base-card-wrapper';
import { BaseCardWrapper } from 'views/components/base/base-card-wrapper';
import { BaseCardWrapper as BaseCardWrapperBetCity } from 'views/components/bet-city/base-card-wrapper';
import { BaseCardWrapper as BaseCardWrapperFonbet } from 'views/components/fonbet/base-card-wrapper';
import { BaseCardWrapper as BaseCardWrapperKase } from 'views/components/kase/base-card-wrapper';
import { CheckView as CheckViewKase } from 'views/components/kase/check-view';
import { BaseCardWrapper as BaseCardWrapperSKStore } from 'views/components/sk-store/base-card-wrapper';
import { BaseCardWrapperSZ } from 'views/components/sz/base-card-wrapper';
import { Layout as Layout1Xbet } from 'views/layouts/1xbet';
import { BaseLayout } from 'views/layouts/base-layout';
import { Layout as LayoutBetCity } from 'views/layouts/bet-city';
import { LayoutSZ } from 'views/layouts/custom-forms/layout-sz';
import { Layout as LayoutFonbet } from 'views/layouts/fonbet';

interface PageConfig {
  [key: string]: {
    Layout: FC<PropsWithChildren>;
    BaseCard: FC;
    ViewCheck?: FC;
  };
}

const PAGE_CONFIG: PageConfig = {
  [FORM_KEY.SZ]: {
    Layout: LayoutSZ,
    BaseCard: BaseCardWrapperSZ,
  },
  [FORM_KEY.XBET]: {
    Layout: Layout1Xbet,
    BaseCard: BaseCardWrapper1Xbet,
  },
  [FORM_KEY.BET_CITY]: {
    Layout: LayoutBetCity,
    BaseCard: BaseCardWrapperBetCity,
  },
  [FORM_KEY.SK_STORE]: {
    Layout: BaseLayout,
    BaseCard: BaseCardWrapperSKStore,
  },
  [FORM_KEY.KASE]: {
    Layout: BaseLayout,
    BaseCard: BaseCardWrapperKase,
    ViewCheck: CheckViewKase,
  },
  [FORM_KEY.FONBET]: {
    Layout: LayoutFonbet,
    BaseCard: BaseCardWrapperFonbet,
  },
  default: {
    Layout: BaseLayout,
    BaseCard: BaseCardWrapper,
  },
};

export { PAGE_CONFIG };
